import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { CreateScheduleSlice } from "../../../CreateSchedule/redux";
import { IFieldDetails } from "../../../CreateSchedule/redux/Types";
import WeeklyDetailsView from "./WeeklyConfig.view";

export interface IWeeklyConfigProp {
  /**
   * Boolean to decide if weekly checkbox to be enabled or disabled
   */
  disabledFields: boolean;
}

/**
 * Component will be rendered for reccurence type weekly. 
 * Responsible for rendering the weekly checkbox components
 */
const WeeklyConfig = (props: IWeeklyConfigProp): JSX.Element => {
  const [selectedWeekDay, setSelectedWeekDay] = useState<IFieldDetails>({
    "value": [] as Array<number>,
    "valid": false,
    "errorText": ""
  });
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const dispatch = useDispatch();
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;
  const { t: translate } = useTranslation();


  const updateWeekReccurenceData = (value: number[]): void => {
    const tempRecurrenceData = {
      ...recurrenceData,
      selectedWeekDays: value
    };
    dispatch(CreateScheduleSlice.actions.setNewScheduleDetails({
      ...scheduling.schedulingDetails,
      recurrenceData: tempRecurrenceData
    }));
  };

  /**
 * On weekly checkboxes will be covered
 * On checkbox selection or unselection value will be updated in selectedWeekDay of redux value
 * Validation - atleast one check box should be selected, mandatory error check implemented
 */
  /* Const onWeekDayCheckBoxSelect = (e: React.SyntheticEvent<any, Event>): void => {
    const selectedDay = parseInt(e.currentTarget.name);
    const isChecked = e.currentTarget.checked;*/
  const onWeekDayCheckBoxSelect = (name: string) => (isChecked: boolean): void => {
    const selectedDay = parseInt(name);
    selectedWeekDay.value = (recurrenceData && recurrenceData.selectedWeekDays) ?
      recurrenceData.selectedWeekDays : [] as Array<number>;
    if (selectedWeekDay.errorText !== "") {
      setSelectedWeekDay({
        "value": selectedWeekDay.value,
        "valid": true,
        "errorText": ""
      });
    }
    if (isChecked) {
      selectedWeekDay.value = [...selectedWeekDay.value, selectedDay];
      updateWeekReccurenceData(selectedWeekDay.value);
    } else {
      let newState = [...selectedWeekDay.value];
      if (selectedWeekDay.value.length > 1) {
        const index = selectedWeekDay.value.indexOf(selectedDay);
        if (index > -1) {
          newState.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        setSelectedWeekDay({
          "value": [],
          "valid": false,
          "errorText": translate("Scheduling.ScheduleErrors.MandatoryFieldError")
        });
        newState = [];
      }
      updateWeekReccurenceData(newState);
    }
  };
  return (
    <WeeklyDetailsView
      onWeekDayCheckBoxSelect={onWeekDayCheckBoxSelect}
      selectedWeekDay={selectedWeekDay}
      disabledFields={props.disabledFields}
    />
  );
};

export default WeeklyConfig;

